module.exports = __webpack_public_path__ + "img/cover4.5a084877.png";